import {
    SETUP_CONNECTOR_DONE, 
    DISABLE_CONNECTOR_DONE,
    typeDataMap
} from '../actions';
/**
 * handles API request success scenario for setup, disable and save operations on connector
 * @param  {Object} state
 * @param  {Object} action
 */
const onConnectorSuccess = (state, action) => {
    let { enabled, smid, type, shouldExpand, ...rest } = action.payload;
    const extras = {};
    if (action.type === SETUP_CONNECTOR_DONE) {
        shouldExpand = true;
    }
    const { sharedMailboxes } = state;
    const currentSM = sharedMailboxes[smid] ? sharedMailboxes[smid] : {};
    const thisConnector = sharedMailboxes[smid] && sharedMailboxes[smid][type] ? sharedMailboxes[smid][type] : {};
    if (rest !== undefined && smid in rest) { 
        const data = rest[smid];
        extras.checkboxOptions = data[typeDataMap[type].checkboxOptions]; //maps `checkboxOptions` to field in response for connector `type`
        extras.selectedValue = data[typeDataMap[type].selectedValue]; //maps `selectedValue` to field in response for connector `type
    }
    if (action.type === DISABLE_CONNECTOR_DONE) {
        extras.checkboxOptions = [];
        extras.selectedValue = '';
    }
    return {
        ...state, 
        isLoading: false,
        sharedMailboxes: {
            ...sharedMailboxes,
            [smid]: { 
                ...currentSM,
                [type]: {
                    ...thisConnector,
                    enabled: !!enabled,
                    shouldExpand, 
                    ...extras
                }
            }
        }
    };
}
export default onConnectorSuccess;